import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            title: 'Home'
        },
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/select',
        name: 'select',
        meta: {
            title: 'select',
            requiresAuth: true
        },
        component: () => import('@/views/selectPage/index.vue')
    },
    {
        path: '/preview3D',
        name: 'preview3D',
        meta: {
            title: 'preview3D',
            requiresAuth: true
        },
        component: () => import('@/views/preview3D/index2.vue')
    },
    {
        path: '/userCenter',
        name: 'userCenter',
        meta: {
            title: '个人信息',
            requiresAuth: true
        },
        component: () => import('@/views/userCenter/index.vue')
    },
    {
        path: '/userCenter/password',
        name: 'userCenterPassword',
        meta: {
            title: '密码修改',
            requiresAuth: true
        },
        component: () => import('@/views/userCenter/password.vue')
    },
    {
        path: '/userCenter/works',
        name: 'userCenterWorks',
        meta: {
            title: '我的作品',
            requiresAuth: true
        },
        component: () => import('@/views/userCenter/works.vue')
    },
    {
        path: '/diy',
        name: 'diy',
        meta: {
            title: 'diy',
            requiresAuth: true
        },
        component: () => import('@/views/diy/index2.vue')
    },
]

const router = new VueRouter({
    routes
})

//页面跳转后回到页面最上端
router.afterEach(() => {
    window.scrollTo(0, 0)
})

export default router
